module.exports = __webpack_public_path__ + "img/20-castle-min.e96cb77b.png";